export const HeaderType = {
    NORMAL: 'normal',
    CASE_STUDY: 'caseStudy',
};
